import { axiosConfig } from './axios-config.js'

export const navbarInfo = {
  // 取得導覽列資訊
  get: (token) => axiosConfig.get('/api/console/bar', token),

  // 更新導覽列資訊
  update: (data, token) => axiosConfig.post('/api/console/bar', data, token)
}
